module.exports = __webpack_public_path__ + "files/a83d3424b6e55b8628f83751432f7f2c.png";